import { create } from 'zustand'

export type SubstitutionModalView = 'ledger' | 'form'

interface OpenArgs {
  view?: SubstitutionModalView
  ingredientName?: string
  ingredientUnit?: string
  showSubmittedConfirmation?: boolean
}

interface SubstitutionModalState {
  open: boolean
  view: SubstitutionModalView
  prefillIngredientName: string | null
  prefillIngredientUnit: string | null
  showSubmittedConfirmation: boolean
  openModal: (args?: OpenArgs) => void
  closeModal: () => void
  setView: (view: SubstitutionModalView) => void
  markConfirmationShown: () => void
}

export const useSubstitutionModal = create<SubstitutionModalState>((set) => ({
  open: false,
  view: 'ledger',
  prefillIngredientName: null,
  prefillIngredientUnit: null,
  showSubmittedConfirmation: false,
  openModal: (args = {}) =>
    set({
      open: true,
      view: args.view ?? 'ledger',
      prefillIngredientName: args.ingredientName ?? null,
      prefillIngredientUnit: args.ingredientUnit ?? null,
      showSubmittedConfirmation: args.showSubmittedConfirmation ?? false,
    }),
  closeModal: () =>
    set({
      open: false,
      showSubmittedConfirmation: false,
      prefillIngredientName: null,
      prefillIngredientUnit: null,
    }),
  setView: (view) => set({ view }),
  markConfirmationShown: () => set({ showSubmittedConfirmation: false }),
}))
